import { InsureInteraction, QuoteInteraction } from './coming-soon-interaction';
import { CloseInteraction } from './close-interaction';
import { ExportInteraction } from './export-interaction';
import { ExtractionInteraction } from './extraction-interaction';
import { RestoreAction } from './restore-interaction';
import { ShareAction } from './share-interaction';
import { TagInteraction } from './tag-interaction';

export const INTERACTIONS = {
  EXPORT: ExportInteraction,
  RESTORE: RestoreAction,
  SHARE: ShareAction,
  TAG: TagInteraction,
  EXTRACT: ExtractionInteraction,
  CLOSE: CloseInteraction,
  INSURE: InsureInteraction,
  QUOTE: QuoteInteraction,
} as const;

export const TABLE_INTERACTIONS = {
  SILOS_PRO: {
    VRR: [
      <INTERACTIONS.EXPORT
        key="export"
        interactionId="export-silopro-vrr"
        list={{ view: 'silospro', tab: 'vrr' }}
      />,
      <INTERACTIONS.TAG key="tag" interactionId="tag-silopro-vrr" />,
      <INTERACTIONS.EXTRACT key="extract" interactionId="extract-silopro-vrr" />,
      <INTERACTIONS.CLOSE key="close" interactionId="close-silopro-vrr" />,
      <INTERACTIONS.INSURE key="insure" interactionId="insure-silopro-vrr" />,
      <INTERACTIONS.QUOTE key="quote" interactionId="quote-silopro-vrr" />,
      <INTERACTIONS.SHARE key="share" actionId="share-silopro-vrr" />,
    ],
    WITHOUT_VRR: [
      <INTERACTIONS.EXPORT
        key="export"
        interactionId="export-silopro-without-vrr"
        list={{ view: 'silospro', tab: 'no-vrr' }}
      />,
      <INTERACTIONS.TAG key="tag" interactionId="tag-silopro-without-vrr" />,
      <INTERACTIONS.EXTRACT key="extract" interactionId="extract-silopro-without-vrr" />,
      <INTERACTIONS.CLOSE key="close" interactionId="close-silopro-without-vrr" />,
      <INTERACTIONS.SHARE key="share" actionId="share-silopro-without-vrr" />,
    ],
    CLOSED: [
      <INTERACTIONS.EXPORT
        key="export"
        interactionId="export-silopro-closed"
        list={{ view: 'silospro', tab: 'closed' }}
      />,
      <INTERACTIONS.TAG key="tag" interactionId="tag-silopro-closed" />,
      <INTERACTIONS.SHARE key="share" actionId="share-silopro-closed" />,
    ],
  },
  SILOBAG: {
    ACTIVE: [
      <INTERACTIONS.EXPORT
        key="export"
        interactionId="export-silobag-active"
        list={{ view: 'silobag', tab: 'active' }}
      />,
      <INTERACTIONS.TAG key="tag" interactionId="tag-silobag-active" />,
      <INTERACTIONS.EXTRACT key="extract" interactionId="extract-silobag-active" />,
      <INTERACTIONS.CLOSE key="close" interactionId="close-silobag-active" />,
      <INTERACTIONS.SHARE key="share" actionId="share-silobag-active" />,
    ],
    CLOSED: [
      <INTERACTIONS.EXPORT
        key="export"
        interactionId="export-silobag-closed"
        list={{ view: 'silobag', tab: 'closed' }}
      />,
      <INTERACTIONS.TAG key="tag" interactionId="tag-silobag-closed" />,
      <INTERACTIONS.SHARE key="share" actionId="share-silobag-closed" />,
    ],
    ARCHIVED: [<INTERACTIONS.RESTORE key="restore" actionId="restore-silobag-archived" />],
  },
} as const;
